import { FormikProps, getIn } from 'formik'
import { ErrorLabel, IRadioOption, Label, Radio } from '..'
import { FontSize } from '../../../_metronic/helpers'

type IFormRadio<T = any> = {
  label?: string
  name: string
  options: IRadioOption<T>[]
  formik: FormikProps<any>
  isDisabled?: boolean
  isRequired?: boolean
  isColumn?: boolean
  isInline?: boolean
  /** Tamanho do radio (ver `Radio`). */
  size?: 'sm' | 'md'
  className?: string
  labelSize?: FontSize
  infoText?: string
  highlight?: boolean
}

export const FormRadio = <T,>({
  label,
  name,
  options,
  formik,
  isDisabled = false,
  isRequired = false,
  isColumn = false,
  isInline = false,
  size,
  className = '',
  labelSize,
  infoText,
  highlight,
}: IFormRadio<T>) => {
  const errorMessage = getIn(formik.errors, name, null)
  const value = getIn(formik.values, name, null)
  const touched = getIn(formik.touched, name, null)

  return (
    <div className={`row ${className}`}>
      <div className={`${isInline ? 'd-flex align-items-center' : ''}`}>
        {label && (
          <Label
            className={`${isInline ? '' : 'mb-2'} me-2`}
            isRequired={isRequired}
            size={labelSize}
            infoText={infoText}
            highlight={highlight}
          >
            {label}
          </Label>
        )}
        <Radio<T>
          id={name}
          options={options}
          onChange={(val) => formik.setFieldValue(name, val)}
          value={value}
          disabled={formik.isSubmitting || isDisabled}
          isColumn={isColumn}
          size={size}
        />
      </div>
      {touched && errorMessage && <ErrorLabel>{errorMessage}</ErrorLabel>}
    </div>
  )
}
